import { AppId } from '@wix/cashier-common/dist/src/enums/AppId';
import { experimentsService } from '@wix/cashier-common/dist/src/utils/experimentsService';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { AdaptedComponentsContext } from '../context/AdaptedComponents';
import { selectAppId, selectIsMerchantContext } from '../redux/selectors';
import { Experiment } from '../types/Experiment';

export const isAdaptedComponentsEnabled = (
  isMerchantContext: boolean,
  appId: AppId
) => {
  if (!isMerchantContext) {
    if (
      appId === AppId.Events &&
      experimentsService.isExperimentEnabled(
        Experiment.EnableTPALibraryForEvents
      )
    ) {
      return true;
    }
    if (
      appId === AppId.Bookings &&
      experimentsService.isExperimentEnabled(
        Experiment.EnableTPALibraryForBookings
      )
    ) {
      return true;
    }
    if (
      appId === AppId.Stores &&
      experimentsService.isExperimentEnabled(
        Experiment.EnableTPALibraryForStores
      )
    ) {
      return true;
    }
    if (
      appId === AppId.Restaurants &&
      experimentsService.isExperimentEnabled(
        Experiment.EnableTPALibraryForRestaurants
      )
    ) {
      return true;
    }
    if (
      appId !== AppId.Events &&
      appId !== AppId.Bookings &&
      appId !== AppId.Stores &&
      appId !== AppId.Restaurants &&
      experimentsService.isExperimentEnabled(
        Experiment.EnableTPALibraryForOthers
      )
    ) {
      return true;
    }
  }

  if (
    isMerchantContext &&
    experimentsService.isExperimentEnabled(Experiment.EnableWSRLibrary)
  ) {
    return true;
  }

  return false;
};

export const useAdaptedComponents = () => {
  const Components = useContext(AdaptedComponentsContext);
  const isMerchantContext = useSelector(selectIsMerchantContext);
  const appId = useSelector(selectAppId);

  return isAdaptedComponentsEnabled(isMerchantContext, appId)
    ? Components
    : null;
};
